/* @ngInject */

export default class RegisterCtrl {
	constructor(
		$scope,
		$state,
		Utility,
		$timeout,
		$rootScope,
		RegisterService,
		NotificationService,
		LocalStorageService,
		CountriesUtilService,
		$location
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.$location = $location;

		this.Utility = Utility;
		this.RegisterService = RegisterService;
		this.NotificationService = NotificationService;
		this.LocalStorageService = LocalStorageService;
		this.CountriesUtilService = CountriesUtilService;

		this.init();
		this.activate();
	}

    activate() {
        let isConfirmed = false;

		if (
			this.$state.params &&
			this.$state.params.hasOwnProperty('email') &&
			this.$state.params.hasOwnProperty('token')
		) {
			this.LocalStorageService.clear("FullSite");
            const { email, token } = this.$state.params;
            if (email && token) {

                this.currentStep = 5;
                this.activationStatus = 'busy';

				this.RegisterService.confirmEmail(email, token).then(
                    (results) => {
                        this.currentStep = 5;
                        isConfirmed = true;
						this.activationStatus = 'done';
						this.$rootScope.$digest();
					},
                    (err) => {
						this.activationStatus = 'error';
						this.$rootScope.$digest();
					}
				);

                this.LocalStorageService.clear("FullSite");
            }
        }
        this.CountriesUtilService.load().then(
            (results) => { },
            (err) => {
                console.error(err);
            }
        );
        if (isConfirmed) {
            this.$rootScope.$broadcast('user-logged-out');
        }
	}

	init() {
		this.selectedCountryCode = '+27';
		this.style = { width: '25%' };

		this.showResendButton = false;

		this.email = '';
		this.name = '';
		this.surname = '';
		this.cellphone = '';
		this.password = '';
		this.confirmPassword = '';

		this.progress = 25;
		this.currentStep = 0;
		this.error = '';

		this.activationStatus = 'busy';
		this.mobileRegStatus = 'done';

		this.isBusy = false;
		this.hasExistingAccount = false;
		this.forgotPasswordSent = false;
	}

	gotoBack() {
		this.currentStep--;
		this.updateProgress();
	}

	gotoNext() {
		this._switchIsBusy(false);
		this.currentStep++;
		this.updateProgress();
	}

	async submit(evt) {
		try {
			let errMsg = '';
			if (this.currentStep === 0) {
				this._switchIsBusy(true);
				this.showResendButton = false;
				this.hasExistingAccount = false;
				this.forgotPasswordSent = false;

				const trimmedEmail = (this.email || '').trim().toLowerCase();

				await this.RegisterService.checkIfUserExists(trimmedEmail);

				if (!this.RegisterService.userAlreadyExists) {
					await this.RegisterService.validateEmail(trimmedEmail);
					this.gotoNext();
				} else {
					if (!this.RegisterService.isUserConfirmed) {
						errMsg = `A confirmation email was sent to ${trimmedEmail} but your account hasn't been verified yet. Please check your inbox, or click below to resend.`;
						this.showResendButton = true;
					} else {
						this.hasExistingAccount = true;
					}
				}

			} else if (this.currentStep === 2) {
				this._switchIsBusy(true);
				const mobileNumber = this.getInternationalMobileNumber();

				const results = await this.RegisterService.registerUser(
					this.email,
					this.name,
					this.surname,
					mobileNumber,
					this.password
				);
				this.gotoNext();
			}

			this.error = errMsg;
		} catch (error) {
			this.showError(error && error.message ? error.message : 'Something went wrong. Please try again or contact Pretor.');
		} finally {
			this._switchIsBusy(false);
		}
	}

	onEmailChange() {
		this.hasExistingAccount = false;
		this.showResendButton = false;
		this.forgotPasswordSent = false;
		this.error = '';
	}

	goToLogin() {
		this.$state.go('login');
	}

	async triggerForgotPassword() {
		try {
			this._switchIsBusy(true);
			await this.RegisterService.forgotPassword(this.email);
			this.forgotPasswordSent = true;
		} catch (err) {
			console.error('Could not send password reset email', err);
		} finally {
			this._switchIsBusy(false);
		}
	}

	async resend() {
		let errMsg = '';

		try {
			const results = await this.RegisterService.resend(this.email);
			errMsg = '';
			this.NotificationService.success('EMAIL RESENT.');
		} catch (error) {
			errMsg = `Error while re-sending your details, please try again or contact Pretor if the error persists.`;
			console.error(error);
		} finally {
			this._switchIsBusy(false);
			this.showError(errMsg);
		}
	}

	updateProgress() {
		this.progress = 25 * (this.currentStep + 1);
		this.style = { width: `${this.progress}%` };
	}

	showError(msg) {
		this.error = msg;
	}

	getInternationalMobileNumber() {
		return `${this.selectedCountryCode}${this.cellphone}`;
	}

	_switchIsBusy(flag) {
		this.$timeout(() => {
			this.isBusy = flag;
		});
	}
}
